import { render, staticRenderFns } from "./show.vue?vue&type=template&id=43db8b0d&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43db8b0d')) {
      api.createRecord('43db8b0d', component.options)
    } else {
      api.reload('43db8b0d', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=43db8b0d&", function () {
      api.rerender('43db8b0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/show.vue"
export default component.exports